import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { sessionExpiryInterceptor } from './interceptors/session-expiry.interceptor';
import { libraryInterceptor } from './features/library/core/library.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // authInterceptor attaches the Bearer token on the way out; sessionExpiryInterceptor catches a
    // 401 on the way back and redirects to the legacy login with a returnUrl to this page.
    // libraryInterceptor handles ONLY /api/library/* (Job Story Library cookie session); the two Admin Portal
    // interceptors skip those URLs, so the library never sends or reacts to the Admin JWT.
    provideHttpClient(withInterceptors([libraryInterceptor, authInterceptor, sessionExpiryInterceptor])),
  ],
};
